/**
 * This code was generated by Builder.io.
 */
import React, { useState } from "react";
import styles from "./CreditUnionSearch.module.css";
import RadioOption from "./RadioOption";
import { useNavigate } from 'react-router-dom';


const CreditUnionSearch: React.FC = () => {
  const [searchOption, setSearchOption] = useState("contractNumber");
  const [searchValue, setSearchValue] = useState("");
  const navigate = useNavigate();

  const handleSearchOptionChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSearchOption(event.target.value);
  };

  const handleSearchInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSearchValue(event.target.value);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    console.log("Search submitted:", { searchOption, searchValue });
    navigate('/PremiumReportList'); 
  };

  return (
    <main className={styles.creditUnionSearch}>
      <header className={styles.header}>
        <div className={styles.headerContent}>
          <div className={styles.logoContainer}>
            <div className={styles.logoWrapper}>
              <div className={styles.logoImage}>
                <img
                  loading="lazy"
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/96bca4b872d79f4423a4a7fa07db8466cf0d170fe4dabb72ca1779e7dcba83d4?placeholderIfAbsent=true&apiKey=56a6c7500c3c464580ff9be9a9daa1d9"
                  alt="Company Logo"
                  className={styles.logo}
                />
              </div>
              <h1 className={styles.title}>Payment Protection Premium</h1>
            </div>
          </div>
          <p className={styles.greeting}>Hello, Joe Smith</p>
        </div>
      </header>
      <section className={styles.mainContent}>
        <div className={styles.searchOptions}>
          <h2 className={styles.searchTitle}>Search Credit Union by:</h2>
          <div className={styles.radioGroup}>
            <RadioOption
              id="contractNumber"
              label="Contract Number"
              checked={searchOption === "contractNumber"}
              onChange={handleSearchOptionChange}
              value="contractNumber"
              name="searchOption"
            />
            <RadioOption
              id="name"
              label="Name"
              checked={searchOption === "name"}
              onChange={handleSearchOptionChange}
              value="name"
              name="searchOption"
            />
            <RadioOption
              id="state"
              label="State"
              checked={searchOption === "state"}
              onChange={handleSearchOptionChange}
              value="state"
              name="searchOption"
            />
            <RadioOption
              id="nameAndState"
              label="Name and State"
              checked={searchOption === "nameAndState"}
              onChange={handleSearchOptionChange}
              value="nameAndState"
              name="searchOption"
            />
          </div>
        </div>
        <form className={styles.searchForm} onSubmit={handleSubmit}>
          <div className={styles.inputWrapper}>
            <div className={styles.textField}>
              <div className={styles.inputStateLayer}>
                <div className={styles.inputContent}>
                  <label htmlFor="searchInput" className={styles.labelText}>
                    {searchOption === "contractNumber"
                      ? "Contract Number"
                      : searchOption === "name"
                      ? "Name"
                    : searchOption === "state"
                    ? "State"
                  : "State & Name"}
                  </label>
                  <input
                    type="text"
                    id="searchInput"
                    className={styles.searchInput}
                    value={searchValue}
                    onChange={handleSearchInputChange}
                    aria-label={
                      searchOption === "contractNumber"
                        ? "Enter Contract Number"
                        : "Enter Name"
                    }
                  />
                </div>
              </div>
            </div>
            <div className={styles.activeIndicator} />
          </div>
          <button type="submit" className={styles.searchButton}>
            <div className={styles.buttonContent}>
              <span className={styles.buttonText}>Search</span>
            </div>
          </button>
        </form>
      </section>
    </main>
  );
};

export default CreditUnionSearch;
